import script from "./X1Dropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./X1Dropdown.vue?vue&type=script&lang=ts&setup=true"

import "./X1Dropdown.vue?vue&type=style&index=0&id=5caa5d64&lang=scss&scoped=true"

import exportComponent from "D:\\x1\\vue3-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5caa5d64"]])

export default __exports__